/**
 * localStorage için güvenli erişim yardımcı fonksiyonları
 * Node.js ortamında (build sırasında) localStorage mevcut olmadığı için güvenli kontroller eklenmiştir
 */

/**
 * localStorage'dan değer okur
 * @param {string} key - localStorage anahtarı
 * @param {any} defaultValue - localStorage mevcut değilse döndürülecek varsayılan değer
 * @returns {string|null} localStorage'daki değer veya varsayılan değer
 */
export const getFromStorage = (key, defaultValue = null) => {
    try {
        if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') {
            return localStorage.getItem(key) || defaultValue;
        }
        return defaultValue;
    } catch (error) {
        console.warn(`localStorage getItem failed for key "${key}":`, error);
        return defaultValue;
    }
};

/**
 * localStorage'a değer yazar
 * @param {string} key - localStorage anahtarı
 * @param {string} value - kaydedilecek değer
 * @returns {boolean} işlem başarılı ise true
 */
export const setToStorage = (key, value) => {
    try {
        if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') {
            localStorage.setItem(key, value);
            return true;
        }
        return false;
    } catch (error) {
        console.warn(`localStorage setItem failed for key "${key}":`, error);
        return false;
    }
};

/**
 * localStorage'dan değer siler
 * @param {string} key - localStorage anahtarı
 * @returns {boolean} işlem başarılı ise true
 */
export const removeFromStorage = (key) => {
    try {
        if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') {
            localStorage.removeItem(key);
            return true;
        }
        return false;
    } catch (error) {
        console.warn(`localStorage removeItem failed for key "${key}":`, error);
        return false;
    }
};

/**
 * localStorage'ın mevcut olup olmadığını kontrol eder
 * @returns {boolean} localStorage mevcut ise true
 */
export const isStorageAvailable = () => {
    try {
        return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
    } catch (error) {
        return false;
    }
};

/**
 * JWT token'ını localStorage'dan güvenli şekilde alır ve decode eder
 * @param {string} tokenKey - token'ın localStorage'daki anahtarı
 * @returns {object|null} decode edilmiş token veya null
 */
export const getDecodedTokenFromStorage = (tokenKey) => {
    try {
        const token = getFromStorage(tokenKey);
        if (!token) {
            return null;
        }
        
        // jwtDecode'u dinamik olarak import et (build sırasında hata vermemesi için)
        if (typeof window !== 'undefined') {
            const jwtDecode = require('jwt-decode').default || require('jwt-decode');
            return jwtDecode(token);
        }
        return null;
    } catch (error) {
        console.warn(`Token decode failed for key "${tokenKey}":`, error);
        return null;
    }
};